import React from 'react'
import {connect} from 'react-redux'
import {string, bool, func, oneOf} from 'prop-types'
import {InputField} from '@agillic/agillic-ui'

import {TFALabel, onChangeHandler, onKeyDownHandler, isTFADisabled, isAutofocus} from '../inputFields.helper'
import {validateTFAInput} from '../inputFields.validation'
import {updateSecretCode} from '../../login.actionCreators'
import {loginModesList} from '../../helpers/login.data'

const TFACode = ({secretCode, mode, isSecretCodeDirty, onUpdateSecretCode, hasAuthFailed, codeSendMessage, isAuthInProgress, isPasswordPolicyPending, onSubmit, isVisible}) => isVisible && (
  <InputField
    label={TFALabel}
    value={secretCode}
    onChange={({target}) => onChangeHandler({target, onUpdate: onUpdateSecretCode})}
    validation={validateTFAInput({hasAuthFailed, secretCode, isSecretCodeDirty})}
    isDisabled={isTFADisabled({isAuthInProgress, codeSendMessage, isPasswordPolicyPending})}
    uniqueID='code'
    onKeyDown={({key}) => onKeyDownHandler({key, onSubmit})}
    autofocus={isAutofocus({mode, field: 'tfa'})}
  />
)

const mapStateToProps = ({loginReducer}) => ({
  isAuthInProgress: loginReducer.isAuthInProgress,
  isPasswordPolicyPending: loginReducer.isPasswordPolicyPending,
  secretCode: loginReducer.secretCode,
  isSecretCodeDirty: loginReducer.isSecretCodeDirty,
  hasAuthFailed: loginReducer.hasAuthFailed,
  codeSendMessage: loginReducer.codeSendMessage,
  mode: loginReducer.mode
})

const mapDispatchToProps = dispatch => ({
  onUpdateSecretCode: value => dispatch(updateSecretCode(value))
})

TFACode.propTypes = {
  isAuthInProgress: bool,
  isPasswordPolicyPending: bool,
  onSubmit: func.isRequired,
  secretCode: string,
  isSecretCodeDirty: bool,
  onUpdateSecretCode: func.isRequired,
  hasAuthFailed: bool,
  codeSendMessage: string,
  isVisible: bool,
  mode: oneOf(loginModesList)
}

export default connect(mapStateToProps, mapDispatchToProps)(TFACode)
